import { usePaymentTransactionStatusSubscription } from '~/api/graphql/subscriptions/paymentTransaction'

import { useSubscriptionRetry } from './useSubscriptionRetry'

/**
 * Custom hook for subscribing to payment transaction status changes
 * Automatically handles subscription retries for network errors
 *
 * @param transactionId - The ID of the payment transaction to subscribe to
 * @returns Object containing transaction data, loading state, and error state
 */
export const usePaymentTransactionStatus = (transactionId: string) => {
  const { data, loading, error, restart } =
    usePaymentTransactionStatusSubscription(transactionId)

  const transaction = data?.paymentTransactionStatus

  useSubscriptionRetry({
    error,
    restart,
    subscriptionName: 'Payment Transaction Status subscription',
  })

  return {
    transaction,
    loading,
    error,
  }
}
